import React from 'react';
import ClassPeriodTradingStatComponent from "./ClassPeriodTradingStatComponent";
import {padCalendar} from "../../../util";

const formatClassPeriodStats = (classPeriodTradingStats) => {
	for (const classPeriodTradingStat of classPeriodTradingStats) {
		classPeriodTradingStat.date = padCalendar(classPeriodTradingStat.date);
	}

	return classPeriodTradingStats;
};

const ClassPeriodTradingStatContainer = (props) => {
	if (!props.classPeriodTradingStats) {
		return <div>Loading</div>
	}

	const data = formatClassPeriodStats(props.classPeriodTradingStats);

	return (
		<React.Fragment>
			<ClassPeriodTradingStatComponent classPeriodTradingStats={data} isDandO={sessionStorage.getItem('DANDO')} claimTypeId={props.claimTypeId}/>
		</React.Fragment>
	);

};


export default ClassPeriodTradingStatContainer;


// WEBPACK FOOTER //
// ./src/common/components/ClassPeriodTradingStat/ClassPeriodTradingStatContainer.js